import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SearchService } from '../search/search.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { QueryResult } from '../search/models/queryresult.model';
import { AlternativeSearchesAvailable } from '../search/models/alternativesearchesavailable.model';
import { SearchParams } from '../search/models/searchParams.model';
import { ExtendedCompanyProfile } from '../profile/models/extendedcompanyprofile.model';
import { ProfileService } from '../profile/profile.service';
import { FilterService } from '../search/filters/filter.service';
import { CompanyCreditService } from '../profile/companyprofile/companycredit/companycredit.service';
import { CompanyCreditInfo } from '../profile/companyprofile/companycredit/models/companycreditinfo.model';
import { User } from './user.model';
import { UserService } from './user.service';
import { DataError } from '../search/models/dataerror.model';
import { SearchResult } from '../search/models/searchresult.model';
declare var $: any;
@Injectable()
export class DataService {
    constructor(
        private http: HttpClient,
        private searchService: SearchService,
        private profileService: ProfileService,
        private filterService: FilterService,
        private companyCreditService: CompanyCreditService,
        private userService: UserService
        ) { 
            if (window
                && "location" in window
                && "protocol" in window.location
                && "host" in window.location) {
                if (window.location.host.toLowerCase().includes('localhost')) {
                    this.apiUrl = 'http://localhost:50206/';
                }
            }
        }
    private currentTerms: string;
    private currentField: string;
    private currentTerms2: string;
    private currentField2: string;
    private radius: number;
    private apiUrl: string = 'https://api.ppai.org/';
    private userToken: string;

    sendFeedbackEmail(feedback: string){
        return this.http.post<string>(
            this.apiUrl + 'directory/sendfeedback',
            {
                'UserEmail': this.userService.getUser().UserEmail,
                'UserMessage': feedback,
                'authToken': this.userToken,
                'Id': this.userService.getUser().Id
            }
        );
    }
    loadUser(authTicket: string) {
        if (authTicket == "") return;
        return this.http.post<User>(
            this.apiUrl + 'directory/user',{
                'AuthTicket': authTicket
            }
        ).pipe(
            map(result => {
                let x = new User(
                    result.FullName,
                    result.Id,
                    result.OldIdentifier,
                    result.CompanyId,
                    result.Category,
                    result.UserEmail,
                    result.IsMember
                );
                this.userService.setUser(x);
                this.userToken = authTicket;
            })
        );
    }

    doSearch() {
        this.getSearchResults(this.currentTerms, this.currentField, this.currentTerms2, this.currentField2, this.radius);
    }
    doAlternateSearch(field: string) {
        this.currentField = field;
        this.getSearchResults(this.currentTerms, field, this.currentTerms2, this.currentField2, this.radius);
    }
    getCreditReportUrl(reportName: string, requestFor: string){
        let user: User = this.userService.getUser();
        return this.http.post<string>(
            this.apiUrl + 'credit/report/',
            {
                'reportName': reportName,
                'requestBy': user.OldIdentifier,
                'requestFor': requestFor,
                'authToken': this.userToken,
                'Id': user.CompanyId
            }
        );
    }
    getCreditInfo(requested: string, requestedUpic: string){
        this.companyCreditService.clearCurrentInfo();
        this.companyCreditService.setIsLoading(true);
        let user: User = this.userService.getUser();
        return this.http.post<CompanyCreditInfo>(
            this.apiUrl + 'credit/info/',
            {
                'requestBy': user.OldIdentifier,
                'requestFor': requested,
                'authToken': this.userToken,
                'Id': user.CompanyId
            } 
        ).subscribe(result => {
                let x = new CompanyCreditInfo(
                    result.CreditDate,
                    result.ForiusID,
                    result.EntityID,
                    result.FileReturnedFromForius,
                    result.ScoreExists,
                    result.Special,
                    result.TradeLineCount,
                    result.YearsInFile,
                    result.IsAuthorized,
                    result.RequestedId,
                    result.CreditProfileRate,
                    result.CreditScanRate,
                    result.ExperianIntelliscoreRate,
                    result.ExperianBusinessProfileRate,
                    result.ExperianBPRScoreComboRate
                );
                this.companyCreditService.setIsLoading(false);
                this.companyCreditService.setCurrentInfo(x);
            },
            error => {
                this.profileService.setIsLoading(false);
                if (error.status == 429){
                    this.searchService.setDataError(
                        new DataError(
                            error.status,
                            error.error.Message,
                            "getCreditInfo"
                        )
                    );
                }
                setTimeout(() => {
                    $(".modal").modal('hide');
                }, 1000);
           });
    }

    getCompanyExtendedProfile(id: string) {
        this.profileService.clearResults();
        this.profileService.setIsLoading(true);
        return this.http.post<ExtendedCompanyProfile>(
            this.apiUrl + 'DirectorySearch/GetExtendedCompanyProfile',{
                'Id': this.userService.getUser().Id,
                'ProfileId': id,
                'authToken': this.userToken
            }
        ).subscribe(result => {
                this.profileService.setIsLoading(false);
                this.profileService.setExtendedCompanyProfile(result);
                return result;
            },
            error => {
                this.profileService.setIsLoading(false);
                if (error.status == 429){
                    this.searchService.setDataError(
                        new DataError(
                            error.status,
                            error.error.Message,
                            "getCompanyExtendedProfile"
                        )
                    );
                }
                setTimeout(() => {
                    $(".modal").modal('hide');
                }, 1000);
           }
        )
    }

    getIndividualProfile(id: string) {
        this.profileService.clearIndividualProfile();
        this.profileService.setIsIndividualLoading(true);
        return this.http.post<QueryResult>(
            this.apiUrl + 'DirectorySearch/GetIndividualProfile',
            {
                'Id': this.userService.getUser().Id,
                'ProfileId': id,
                'authToken': this.userToken
            }
        ).subscribe(
            result => {
                this.profileService.setIsIndividualLoading(false);
                this.profileService.setIndividualProfile(result.CurrentResults[0]);
            },
            error => {
                this.profileService.setIsIndividualLoading(false);
                if (error.status == 429){
                    this.searchService.setDataError(
                        new DataError(
                            error.status,
                            error.error.Message,
                            "getIndividualProfile"
                        )
                    );
                }
                setTimeout(() => {
                    $(".modal").modal('hide');
                }, 1000);
           }
        )
    }

    getSearchResults(terms: string, field: string, terms2: string, field2: string, radius: number) {
        if (terms == undefined || (terms.length === 0 && terms2.length === 0)) return;
        this.searchService.clearResults();
        this.searchService.setIsLoading(true);
        this.searchService.setDataError(null);

        this.currentTerms = terms;
        this.currentField = field;
        this.currentTerms2 = terms2;
        this.currentField2 = field2;
        let filters = this.filterService.getSearchFilters();
        var includeAssociates = false;
        var includeSuppliers = false;
        var includeDistributors = false;
        var includeTradeAssociations = false;
        var includeBusinessServices = false;
        var includeSupplierReps = false;
        var includeInternationalDistributors = false;
        var includeInternationalSuppliers = false;

        filters.forEach(element => {
            if (element.Expression === 'D') { includeDistributors = element.Checked == true; }
            if (element.Expression === 'S') { includeSuppliers = element.Checked == true; }
            if (element.Expression === 'M') { includeAssociates = element.Checked == true; }
            if (element.Expression === 'T') { includeTradeAssociations = element.Checked == true; }
            if (element.Expression === 'A') { includeBusinessServices = element.Checked == true; }
            if (element.Expression === 'R') { includeSupplierReps = element.Checked == true; }
            if (element.Expression === 'ID') { includeInternationalDistributors = element.Checked == true; }
            if (element.Expression === 'IS') { includeInternationalSuppliers = element.Checked == true; }
        });
        // let headers = new HttpHeaders();
        // headers = headers.set('Authorization','erotiew[rptoiewr[potiewp[rotiew');
        return this.http.post<QueryResult>(
            this.apiUrl + 'DirectorySearch/Search',
            {
                'Id': this.userService.getUser().Id,
                'Terms': terms,
                'Field': field,
                'Terms2': terms2,
                'Field2': field2,
                'IncludeAssociates': includeAssociates,
                'IncludeBusinessServices': includeBusinessServices,
                'IncludeDistributors': includeDistributors,
                'IncludeSuppliers': includeSuppliers,
                'IncludeInternationalDistributors': includeInternationalDistributors,
                'IncludeInternationalSuppliers': includeInternationalSuppliers,
                'IncludeSupplierReps': includeSupplierReps,
                'IncludeTradeAssociations': includeTradeAssociations,
                'authToken': this.userToken,
                'SalesVolumeFrom': this.filterService.svRangeFrom,
                'SalesVolumeTo': this.filterService.svRangeTo,
                'Radius': radius
            }
        ).subscribe(
            results => {
                this.searchService.setIsLoading(false);
                this.searchService.setSearchResults(results.CurrentResults);
                this.searchService.setAlternativeSearchesAvailable(
                    new AlternativeSearchesAvailable(
                        results.CompanyNameResultCount,
                        results.IdResultCount,
                        results.FullNameResultCount,
                        results.ProductCategoryResultCount,
                        results.BrandNamesResultCount,
                        results.CompanyDescriptionResultCount,
                        results.CompanyCityResultCount,
                        results.CompanyStateResultCount,
                        results.CompanyCountryResultCount,
                        results.WebsiteResultCount,
                        results.CompanyEmailResultCount,
                        results.IndividualEmailResultCount,
                        results.ZipResultCount,
                        results.CompanyPhoneResultCount,
                        results.IndividualPhoneResultCount
                    )
                );
                this.searchService.setSearchFields(new SearchParams(terms, field, terms2, field2, radius, results.IsRadiusSearch));
             },
             error => {
                 this.searchService.setIsLoading(false);
                 if (error.status == 429){
                     this.searchService.setDataError(
                         new DataError(
                             error.status,
                             error.error.Message,
                             "getSearchResults"
                         )
                     );
                 }
            }
        )
    }
    setUserToken(token: string){
        this.userToken = token;
    }
}
